<template>
  <div class="auth-list-box-2-wrap">
    <div class="line-1">
      <el-checkbox :indeterminate="isIndeterminate" :label="box_data.right_id" v-model="checkAll" @change="check_all_change">{{ box_data.label }}</el-checkbox>
    </div>
    <div class="line-2">
      <el-checkbox-group v-model="entity_data" @change="checked_change">
        <el-checkbox v-for="(item, key) in box_data.entity" :key="key" :label="item">{{ item }}</el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
    export default {
      props: {
        box_data: {}
      },
      data(){
        return {
          entity_data: this.box_data.current_entity,
          checkAll: false,
          isIndeterminate: true,
        }
      },
      watch: {
        "box_data.current_entity"(val) {
          this.entity_data = this.box_data.current_entity;
          this.checked_change(this.entity_data, "init");
        }
      },
      methods: {
        check_all_change(val) {
          this.entity_data = val ? this.box_data.entity : [];
          this.isIndeterminate = false;
          this.checked_change(this.entity_data);
        },
        checked_change(val=this.entity_data, type) {
          let checkedCount = val.length;
          this.checkAll = checkedCount === this.box_data.entity.length;
          this.isIndeterminate = checkedCount > 0 && checkedCount < this.box_data.entity.length;
          if (!type) {
            this.$emit("check_change", this.Get_Data());
          }
        },
        Get_Data() {
          let _temp = {
            right_id: this.box_data.right_id,
            entity: this.entity_data,
            check: false
          };
          if (this.isIndeterminate) {
            _temp.check = true;
          } else if (this.box_data.entity.length == _temp.entity.length) {
            _temp.check = true;
          }
          return _temp;
        }
      },
      mounted() {
        this.checked_change(this.entity_data, "init");
      }
    }
</script>

<style lang="scss">
  .auth-list-box-2-wrap {
    display: flex;
    position: relative;
    flex-direction: column;

    .line-1 {
      flex: 0 0 auto;
      display: flex;
      margin: 5px 0 5px 0;
    }

    .line-2 {
      flex: 0 0 auto;
      display: flex;
      margin: 3px 0 3px 23px;

      .el-checkbox {
        margin-right: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// authList_box_2.vue?0fcd44cb